/* ========================= */
/* 🟢 IMPORTS */
/* ========================= */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initSession } from './auth'
import '@fortawesome/fontawesome-free/css/all.css'
/* ========================= */
/* 🚀 APP INIT */
/* ========================= */

const app = createApp(App)
const pinia = createPinia()

initSession().then(() => {
  app.use(pinia)
  app.use(router)
  app.mount('#app')
})